module.exports = __webpack_public_path__ + "media/images/error/coming-soon-e1a3df46d7c4ccbee7b0b643042e4eef.svg";